import { render, staticRenderFns } from "./error-container.vue?vue&type=template&id=f9524e1e"
import script from "./error-container.vue?vue&type=script&lang=js"
export * from "./error-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9524e1e')) {
      api.createRecord('f9524e1e', component.options)
    } else {
      api.reload('f9524e1e', component.options)
    }
    module.hot.accept("./error-container.vue?vue&type=template&id=f9524e1e", function () {
      api.rerender('f9524e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/error-container.vue"
export default component.exports